/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/PDFExtractorOptions.yaml
/**
Options for extracting images from a PDF document.
*/
export class PdfExtractorOptions {
    /** @param source {@displayType `DeepPartial<PdfExtractorOptions>`} */
    constructor(source = {}) {
        /**
          The quality that each extracted image should have. This tweaks the compression, affecting the final image file size. (100 - maximum quality, 0 - minimum quality).
          
          Default is 90
          */
        this.quality = 90;
        /**
          Scaling factor applied to the PDF media box frame while extracting.
          
          Default is 2
          */
        this.scaling = 2.0;
        if (source.quality !== undefined) {
            this.quality = source.quality;
        }
        if (source.scaling !== undefined) {
            this.scaling = source.scaling;
        }
    }
}
//# sourceMappingURL=PdfExtractorOptions.js.map